
import { Pipe, PipeTransform } from '@angular/core';

/**
 * @description Retorna o nome do ícone para cada um dos tipos de pagamento
 * */
@Pipe({name: 'typeOfPaymentsIcon'})
export class TypeOfPaymentsIconPipe implements PipeTransform {

  transform(value: string): string {

    switch (value) {
      case 'BOLETO':
        return 'line_weight'
      case 'CARNE':
        return 'receipt'
      case 'CARTAO_CREDITO':
        return 'credit_card'
      case 'DINHEIRO':
        return 'payments'
      case 'PIX':
        return 'qr_code_2'
      case 'CARTAO_DEBITO':
        return 'credit_card'
      default:
        return 'payments'
    }
  }
}
